module.exports = __webpack_public_path__ + "img/arrow_left_circle.47c24269.svg";